import { Mail, MapPin, Phone } from "lucide-react";
import { Link } from "@/components/common/Link";
import { MenuProvider, useMenu } from "@/integrations/wordpress/WordPressMenuProvider";
import { NavigationMenu, NavigationMenuItem, NavigationMenuLink, NavigationMenuList } from "@/components/ui/navigation-menu";
function FooterMenuConsumer() {
  const {
    menuItems,
    loading
  } = useMenu();
  if (loading) {
    return <div className="flex flex-col gap-2">
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded" />
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded" />
        <div className="h-4 w-24 bg-white/10 animate-pulse rounded" />
      </div>;
  }
  return <NavigationMenu viewport={false}>
      <NavigationMenuList className="flex-col items-start gap-2">
        {menuItems.map((item, i) => <NavigationMenuItem key={item.id} data-index={i}>
            <NavigationMenuLink asChild>
              <Link to={item.href || "#"} className="text-white/80 hover:text-white transition-colors duration-200">
                {item.label}
              </Link>
            </NavigationMenuLink>
          </NavigationMenuItem>)}
      </NavigationMenuList>
    </NavigationMenu>;
}
export default function Footer() {
  return <footer className="bg-[oklch(0.18_0_0)] text-white py-12">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-8 lg:gap-12">
          {}
          <div className="md:col-span-4">
            <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1409808/img/website_logo_white.png" alt="Columbia Valley Waste & Recycling" className="h-7 mb-4" />
            <p className="text-white/60 text-sm leading-relaxed">Junk Removal Calgary<br />Junk Removal Canmore<br />Junk Removal Windermere<br />Junk Removal Radium Hot Springs&nbsp;<br />Junk Removal Fairmont Hot Springs&nbsp;<br />Junk Removal Invermere<br />Junk Removal Panorama</p>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="text-lg font-semibold mb-4">Contact Us</h3>
            <div className="space-y-3">
              <div className="flex items-start gap-3">
                <MapPin className="size-5 text-[oklch(0.64_0.15_35)] shrink-0 mt-0.5" />
                <span className="text-white/80 text-sm">Calgary, Canmore, Columbia Valley</span>
              </div>
              <div className="flex items-start gap-3">
                <Mail className="size-5 text-[oklch(0.64_0.15_35)] shrink-0 mt-0.5" />
                <Link to="mailto:info@columbiavalleywaste.com" className="text-white/80 hover:text-white transition-colors duration-200 text-sm">
                  info@columbiavalleywaste.com
                </Link>
              </div>
              <div className="flex items-start gap-3">
                <Phone className="size-5 text-[oklch(0.64_0.15_35)] shrink-0 mt-0.5" />
                <Link to="tel:236.302.4912" className="text-white/80 hover:text-white transition-colors duration-200 text-sm">
                  236.302.4912
                </Link>
              </div>
            </div>
          </div>

          {}
          <div className="md:col-span-4">
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <MenuProvider menu_id="24">
              <FooterMenuConsumer />
            </MenuProvider>
          </div>
        </div>

        {}
        <div className="mt-12 pt-8 border-t border-white/10">
          <div className="flex flex-col md:flex-row justify-between items-center gap-4">
            <p className="text-white/60 text-sm">
              © {new Date().getFullYear()} Columbia Valley Waste & Recycling. All rights reserved.
            </p>
            
          </div>
        </div>
      </div>
    </footer>;
}